<ul id="contractLengths" class="contract-lengths">
  <ng-template ngFor let-cLength [ngForOf]="(this.contractLengthButtonsToShow$ | async) || contractLengths">
    <!-- default contract lengths-->
    <li>
      <div>
        <button
          mat-flat-button
          style="margin-top: 0px;"
          [class.selected]="cLength.selected"
          (click)="lengthClicked(cLength)"
          [disabled]="isReadOnly"
          >{{cLength.months}}
        </button>
      </div>
    </li>

  </ng-template>

  <li *ngIf="showAllButton" class="standard" [class.outlined]="false" [class.selected]="allSelected && (sweetSpotCheckBoxState$ | async)"
    [class.disabled]="isReadOnly" (click)="allClicked()"><span>All</span>
  </li>

  <!-- custom contract lengths -->
  <ng-template ngFor let-ccLength [ngForOf]="customContractLengths">

    <li *ngIf="showPlusButton">
      <div class="contractLengthButton">
          <span 
            *ngIf="!isReadOnly" 
            (click)="closeCustom(ccLength)"
            class="closeCustom">&times;
          </span>
          <input
            class="customInput"
            (focusout)="customFocusOut($event)"
            [disabled]="ccLength.selected || isReadOnly"
            [value]="ccLength.months || '1'"
            type="number"
            min="1"
            matInput/>
      </div>
    </li>

    <li *ngIf="!showPlusButton">
      <div class="contractLengthButton">
        <button
          mat-flat-button
          style="margin-top: 0px;"
          [disabled]="!ccLength.selected || isReadOnly"
          [class.selected]="ccLength.selected"
          (click)="lengthClicked(ccLength)"
          >{{ccLength.months}}
        </button>
      </div>
    </li>

  </ng-template>

  <!-- plus and all buttons -->
  <div *ngIf="showPlusButton">
    <li>
        <button
          mat-flat-button
          style="margin-top: 0px;"
          (click)="plusClicked($event)"
          [disabled]="isReadOnly">
          <span>+</span>
        </button>
    </li>
  </div>

</ul>
<div *ngIf="showMessage">
    <mat-error aria-atomic="true" class="mat-error" aria-live="polite" id="mat-error"><small>{{message}}</small></mat-error>
</div>